import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import PortfolioPage from './PortfolioPage';
import ResumePage from './pages/resume/ResumePage';
import PrintResumePage from './pages/resume/PrintResumePage';
import EngineeringTimelinePage from './pages/EngineeringTimelinePage';
import CoverLetterPage from './pages/cover-letter/CoverLetterPage';
import './index.scss';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/work" element={<PortfolioPage />} />
        <Route path="/timeline" element={<EngineeringTimelinePage />} />
        <Route path="/resume" element={<ResumePage />} />
        <Route path="/cover-letter" element={<CoverLetterPage />} />
        <Route path="/resume/print" element={<PrintResumePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
